<template>
    <section>
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(saveProcess)">
                <div class="modal-card" style="width: 1080px">
                    <header class="modal-card-head">
                        <p v-if="update" class="modal-card-title">Editar Proceso</p>
                        <p v-if="create" class="modal-card-title">Habilitar Nuevo Proceso</p>
                        <p v-if="proceed" class="modal-card-title">Avanzar Fase</p>
                        <button type="button" class="delete" @click="$emit('close')" />
                    </header>
                    <section class="modal-card-body">

                        <div class="columns">
                            <div class="column">
                                <ValidationProvider name="Fase" rules="required" v-slot="{ errors, failedRules }">
                                    <b-field label="Fase *" :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                                        :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                                        <multiselect v-model="process.phase_d_type_id"
                                            :options="phases_types.map(type => type.id)"
                                            :custom-label="opt => phases_types.find(x => x.id === opt).alt_name"
                                            placeholder="Seleccione una Fase" selectLabel="Presione para seleccionar"
                                            selectedLabel="Seleccionado" deselectLabel="Presione para deseleccionar"
                                            :allow-empty="false" disabled>
                                            <template v-slot:noOptions>
                                                No existen datos
                                            </template>
                                            <span slot="noResult">
                                                No se encontraron elementos.
                                            </span>
                                        </multiselect>
                                    </b-field>
                                </ValidationProvider>
                            </div>

                            <div class="column">
                                <ValidationProvider name="Año" rules="required" v-slot="{ errors, failedRules }">
                                    <b-field label="Año *" :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                                        :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                                        <multiselect v-model="process.year" :options="years"
                                            placeholder="Seleccione un Año" selectLabel="Presione para seleccionar"
                                            selectedLabel="Seleccionado" deselectLabel="Presione para deseleccionar"
                                            :allow-empty="false" :disabled="update || proceed">
                                            <template v-slot:noOptions>
                                                No existen datos
                                            </template>
                                            <span slot="noResult">
                                                No se encontraron elementos.
                                            </span>
                                        </multiselect>
                                    </b-field>
                                </ValidationProvider>
                            </div>
                        </div>

                        <div class="columns mb-6">
                            <div class="column">
                                <ValidationProvider name="Fecha de Inicio"
                                    :rules="{ start_date_before_end_date: process.end_date, required: true }"
                                    v-slot="{ errors, failedRules }">
                                    <b-field label="Fecha de Inicio *"
                                        :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                                        :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                                        <b-datepicker v-model="process.start_date" icon="calendar-alt" trap-focus
                                            locale="es-ES" editable placeholder="dd/mm/aaaa" />
                                    </b-field>
                                </ValidationProvider>
                            </div>

                            <div class="column">
                                <ValidationProvider name="Fecha de Término"
                                    :rules="{ end_date_not_before_start_date: process.start_date, required: true }"
                                    v-slot="{ errors, failedRules }">
                                    <b-field label="Fecha de Término"
                                        :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                                        :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                                        <b-datepicker v-model="process.end_date" icon="calendar-alt" trap-focus
                                            locale="es-ES" editable placeholder="dd/mm/aaaa">
                                        </b-datepicker>
                                    </b-field>
                                </ValidationProvider>
                            </div>
                        </div>

                        <b-message type="is-info" has-icon>
                            Las fechas de inicio y término de cada una de las fases propuestas 
                            por el sistema se basan en el documento <b>"Reglamento de Evaluación y Calificación del Desempeño Académico 2009"</b>.
                        </b-message>
                        
                        <br>
                        <br>

                        <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false" />
                    </section>
                </div>
                <footer class="modal-card-foot is-flex is-justify-content-space-between">
                    <b-button label="Cerrar" @click="$emit('close')" />
                    <b-button v-if="create" label="Habilitar Nuevo Proceso" type="is-success" icon-left="check"
                        @click="saveProcess()" />
                    <b-button v-if="update" label="Editar Fase" type="is-warning" icon-left="edit"
                        @click="confirmChange()" />
                    <b-button v-if="proceed" label="Avanzar Fase" type="is-blue-color" icon-left="forward"
                        @click="confirmChange()" />
                </footer>
            </form>
        </ValidationObserver>
    </section>
</template>

<script>
import axios from 'axios';
import { update } from 'lodash';
import moment from 'moment';
export default {
    name: 'NewEditProcessModal',

    props: {
        update: {
            type: Boolean,
            required: false,
            default: false
        },
        create: {
            type: Boolean,
            required: false,
            default: false
        },
        proceed: {
            type: Boolean,
            required: false,
            default: false
        },
        processIdSelected: {
            type: Number,
            required: false,
            default: null
        }
    },

    data() {
        return {
            //Auxiliares
            isLoading: false,
            years: Array.from({ length: (new Date().getFullYear() - 2000 + 1) }, (v, k) => k + 2000).reverse(),

            //Datos a Traer
            phases_types: [],

            //Datos a Guardar
            process: {
                phase_d_type_id: null,
                year: null,
                start_date: null,
                end_date: null,
            }
        }
    },

    async created() {
        await this.getTypePhases();
        if (this.update || this.proceed) {
            await this.getProcess();
        }
    },

    methods: {
        async getTypePhases() {
            this.isLoading = true;
            await axios
                .get('/phase_d_types.json')
                .then(response => {
                    this.phases_types = response.data

                    this.process.start_date = new Date(moment(this.phases_types[0].start_date, ["YYYY-MM-DD", "DD-MM-YYYY"]))
                    this.process.end_date = new Date(moment(this.phases_types[0].end_date, ["YYYY-MM-DD", "DD-MM-YYYY"]))
                    this.process.phase_d_type_id = this.phases_types[0].id
                    this.process.year = new Date().getFullYear()
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al intentar obtener datos. Intente más tarde',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                    this.$emit('close');
                })
                .finally(() => {
                    this.isLoading = false
                })
        },

        async getProcess() {
            this.isLoading = true;
            await axios
                .get('/performance_phases/' + this.processIdSelected + '.json')
                .then(response => {
                    this.process = response.data;

                    this.process.phase_d_type_id = this.proceed ? this.process.phase_d_type.id + 1 : this.process.phase_d_type.id
                    if (this.proceed) {
                        this.process.start_date = new Date(moment(this.phases_types.find((type) => type.id === this.process.phase_d_type_id).start_date, ["YYYY-MM-DD", "DD-MM-YYYY"]))
                        this.process.end_date = new Date(moment(this.phases_types.find((type) => type.id === this.process.phase_d_type_id).end_date, ["YYYY-MM-DD", "DD-MM-YYYY"]))
                    } else {
                        this.process.start_date = new Date(moment(this.process.start_date, ["YYYY-MM-DD", "DD-MM-YYYY"]))
                        this.process.end_date = new Date(moment(this.process.end_date, ["YYYY-MM-DD", "DD-MM-YYYY"]))
                    }

                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al traer la información del Proceso. Intente más tarde',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                    this.$emit('close');
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        async saveProcess() {
            let valid = await this.$refs.observer.validate()
            if (!valid) {
                this.$buefy.dialog.alert({
                    title: 'Error',
                    message: 'Existe un error en uno de los campos, favor de revisar.',
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'times-circle',
                    iconPack: 'fa',
                    ariaRole: 'alertdialog',
                    ariaModal: true
                })
                return;
            }

            this.isLoading = true;
            await axios
                .post('/performance_phases.json', {
                    performance_phase: this.process
                })
                .then(response => {
                    this.$buefy.dialog.alert({
                        title: 'Éxito',
                        message: `Se ha iniciado el Proceso correspondiente al año ${this.process.year} en la fase ${this.phases_types.find((type) => type.id === this.process.phase_d_type_id).alt_name}.`,
                        type: 'is-success',
                        hasIcon: true,
                        icon: 'check-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                    this.$emit('refresh');
                    this.$emit('close');
                })
                .catch(error => {
                    if (error.response.data.errors) {
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: error.response.data.errors,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    } else {
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: 'Hubo un error al intentar iniciar un nuevo Proceso. Intente más tarde',
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    }
                })
                .finally(() => {
                    this.isLoading = false
                })
        },

        confirmChange() {
            let message = this.update ? 
            `¿Está seguro de editar las fechas de la fase ${this.process.phase_d_type.alt_name}?<br>Esta acción conlleva a <b>habilitar o deshabilitar</b> a los usuarios el ingreso de información correspondiente a la fase actual.` : 
            '¿Está seguro de avanzar el proceso?<br>Esta acción conlleva a que <b>no se pueda volver atrás</b> en el proceso, además a los usuarios que no hayan emitido sus declaraciones pasarán de igual forma a la siguiente fase <b>sin la posibilidad de emitir su información</b> de la fase anterior.'
            this.$buefy.dialog.confirm({
                title: this.update ? 'Editar Proceso' : 'Avanzar Proceso',
                message: message,
                type: 'is-warning',
                ariaRole: 'alertdialog',
                ariaModal: true,
                cancelText: 'Cancelar',
                onConfirm: () => {
                    if (this.update) {
                        this.checkEdit();
                    } else {
                        this.checkProceed();
                    }
                }
            })
        },

        async checkProceed() {
            let valid = await this.$refs.observer.validate()
            if (!valid) {
                this.$buefy.dialog.alert({
                    title: 'Error',
                    message: 'Existe un error en uno de los campos, favor de revisar.',
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'times-circle',
                    iconPack: 'fa',
                    ariaRole: 'alertdialog',
                    ariaModal: true
                })
                return;
            }

            this.isLoading = true;
            await axios
                .post('/performance_phases/advance_process.json', {
                    performance_phase: this.process
                })
                .then(response => {
                    this.$buefy.dialog.alert({
                        title: 'Éxito',
                        message: 'El Proceso ' + this.process.year + ' ha avanzado a la Fase ' + this.phases_types.find((type) => type.id === this.process.phase_d_type_id).alt_name,
                        type: 'is-success',
                        hasIcon: true,
                        icon: 'check-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                    this.$emit('refresh');
                })
                .catch(error => {
                    if (error.response.data.errors) {
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: error.response.data.errors,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    } else {
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: 'Hubo un error al intentar avanzar de fase en el Proceso. Intente más tarde',
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    }
                })
                .finally(() => {
                    this.$emit('close');
                    this.isLoading = false
                })
        },

        async checkEdit() {
            let valid = await this.$refs.observer.validate()
            if (!valid) {
                this.$buefy.dialog.alert({
                    title: 'Error',
                    message: 'Existe un error en uno de los campos, favor de revisar.',
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'times-circle',
                    iconPack: 'fa',
                    ariaRole: 'alertdialog',
                    ariaModal: true
                })
                return;
            }

            this.isLoading = true;
            await axios
                .put('/performance_phases/update_process_dates.json', {
                    id: this.processIdSelected,
                    performance_phase: this.process
                })
                .then(response => {
                    this.$buefy.dialog.alert({
                        title: 'Éxito',
                        message: 'Se ha editado la Fase ' + this.phases_types.find((type) => type.id === this.process.phase_d_type_id).alt_name + ' del Proceso ' + this.process.year + '.',
                        type: 'is-success',
                        hasIcon: true,
                        icon: 'check-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                    this.$emit('refreshProcess', this.process);
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al intentar editar la Fase ' + this.phases_types.find((type) => type.id === this.process.phase_d_type_id).alt_name + ' del Proceso. Intente más tarde',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                })
                .finally(() => {
                    this.$emit('close');
                    this.isLoading = false
                })
        },
    }
}
</script>